<template>
    <b-row>
        <b-col md="12"
            ><component-header
                title="Create Concern"
                :hasSearch="false"
                :hasCreate="false"
                :hasReload="false"
        /></b-col>
        <b-col md="12" class="pb-0 pt-0 mt-2">
            <b-card class="custome-card mb-3">
                <b-row>
                    <b-col md="4">
                        <b-form-input
                            inputType="text"
                            placeholder="Enter Concern Name"
                            class="mt-0"
                            v-model="concernInput"
                        />
                    </b-col>
                    <b-col md="1"></b-col>
                    <b-col md="4" class="d-flex align-items-center">
                        <h4 class="">Concern Type</h4>
                        <b-form-radio-group
                            id="radio-group-2"
                            v-model="selected"
                            name="radio-sub-component"
                        >
                            <b-form-radio
                                value="system"
                                name="radio-size"
                                size="lg"
                            >
                                <span class="ml-2">System</span>
                            </b-form-radio>
                            <b-form-radio
                                value="custom"
                                name="radio-size"
                                size="lg"
                            >
                                <span class="ml-2">Custom</span>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-col>
                    <b-col md="1"></b-col>
                    <b-col md="2" class="text-right">
                        <button
                            type="button"
                            class="btn btn-primary w-90"
                            classic="mr-1 btn-primary"
                            text="Save"
                            @click="showCreateConsern"
                        >
                            Save
                        </button>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
        <b-col md="12" class="pt-0 pb-0 mb-1">
            <b-row>
                <b-col md="5" class="pt-0 pb-0"
                    ><h3 class="mt-3 mb-3">Concern List</h3></b-col
                >
                <b-col md="3" class="pt-0 pb-0">
                    <eb-select
                        type="select"
                        v-model="selectConcern"
                        :options="options"
                        label="text"
                        id="valueConcern"
                        class="mt-2 mb-2"
                        placeholder="Search Type"
                        @input="onChangeConcernType"
                    ></eb-select>
                </b-col>
                <b-col md="3" class="pt-0 pb-0">
                    <div v-if="selectConcern.value == 'name'">
                        <Vue-Simple-Suggest
                            class="mt-2 mb-2"
                            :nullable-select="true"
                            v-model="searchConcernInput"
                            @keyup.enter.native="searchConcernResult()"
                            :debounce="1000"
                            display-attribute="name"
                            value-attribute="_id"
                            placeholder="Search Concern Name"
                        ></Vue-Simple-Suggest>
                        <button
                            class="text-grey searchIcon"
                            @click="searchConcernResult()"
                        >
                            <i class="fa fa-search mt-3" aria-hidden="true"></i>
                        </button>
                    </div>
                    <eb-select
                        v-else
                        type="select"
                        v-model="selectConcernType"
                        :options="optionsConcern"
                        label="text"
                        id="valueType"
                        class="mt-2 mb-2"
                        placeholder="Select Concern Type"
                        @input="searchConcernResult"
                    ></eb-select>
                </b-col>
                <b-col md="1" class="pt-0 pb-0">
                    <div class="text-right mt-2 mb-2 mr-2">
                        <b-button
                            size="sm"
                            variant="success"
                            class="my-2 mr-2 my-sm-0"
                            @click="reloadPage"
                        >
                            <span
                                v-if="loading"
                                class="fa fa-refresh fa-spin"
                                style="font-size: 15px"
                            />
                            <span
                                v-else
                                class="fa fa-refresh"
                                style="font-size: 15px"
                            />
                        </b-button>
                    </div>
                </b-col>
            </b-row>
        </b-col>
        <b-col md="12">
            <b-card class="custome-card">
                <div>
                    <b-table
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        :items="concernOptionData"
                        :fields="concernListData"
                        :current-page="currentPage"
                        :per-page="perPage"
                        @filtered="onFilter"
                        thead-class="header"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(createdAt)" slot-scope="data">
                            <div>
                                {{
                                    moment(String(data.item.createdAt)).format(
                                        "DD/MM/YYYY hh:mm A",
                                    )
                                }}
                            </div>
                        </template>
                        <template slot="cell(action)" slot-scope="data">
                            <div class="d-flex">
                                <div>
                                    <b-button
                                        size="sm"
                                        class="button-circle"
                                        variant="danger"
                                        @click="deleteConcernlist(data.item)"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                </div>
                            </div>
                        </template>
                        <template slot="empty">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="concernOptionData.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import { mapState } from "vuex";
import ebSelect from "@/components/FormElements/Select.vue";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import loader from "@/components/loader/nipigeloader.vue";
import Vue from "vue";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader/index.vue";
Vue.prototype.moment = moment;
export default {
    name: "concern",
    data() {
        return {
            concernInput: "",
            selected: "system",
            filterCount: 0,
            loading: false,
            perPage: 10,
            currentPage: 1,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
            deliverys: [], 
            concernListData: [
                {
                    key: "name",
                    label: "Concern Name",
                },
                {
                    key: "type",
                    label: "Concern Type",
                },
                {
                    key: "createdAt",
                    label: "Created Date",
                },
                {
                    key: "action",
                    label: "Action",
                },
            ],
            searchConcernInput: "",
            selectConcern: "name",
            options: [
                { text: "Concern Name", value: "name" },
                { text: "Concern Type", value: "type" },
            ],
            selectConcernType: "custom",
            optionsConcern: [
                { text: "System", value: "system" },
                { text: "Custom", value: "custom" },
            ],
        };
    },
    components: {
        loader,
        VueSimpleSuggest,
        ebSelect,
        ComponentHeader,
    },
    computed: {
        ...mapState({
            concernOptionData: (state) => state.concern.concernOptionData,
        }),
    },
    methods: {
        onChangeConcernType() {
            this.searchConcernInput = "";
            this.selectConcernType = "";
        },
        async showCreateConsern() {
            if (this.concernInput != "") {
                let payload = {
                    name: this.concernInput,
                    type: this.selected,
                    active: true,
                };
                await this.$store.dispatch("concern/concernCreate", payload);
                this.$swal({
                    title: "success!",
                    text: "Your Concern is Submitted successfully!",
                    type: "success",
                });
                this.reloadPage();
                this.concernInput = "";
                this.selected = "system";
            } else {
                this.$swal({
                    title: "Error!",
                    text: "Please Enter Concern Name!",
                    type: "warning",
                });
            }
        },

        async deleteConcernlist(data) {
            this.$swal({
                title: "Delete this Concern?",
                text: "Are you sure? This will be Remove?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.loading = true;
                    this.$store
                        .dispatch("concern/ConcernDeleteAction", data._id)
                        .then((result) => {
                            this.$swal({
                                type: "success",
                                title: "Success",
                                text: "Concern Deleted Successfully!",
                            });
                            this.reloadPage();
                            this.loading = false;
                        });
                }
            });
        },
        async searchConcernResult() {
            let payload = {
                name: this.searchConcernInput,
                type: this.selectConcernType.value || "",
            };

            await this.$store.dispatch("concern/concernFilterAction", payload);
        },
        async reloadPage() {
            this.loading = true;
            let payload = {
                name: "",
                type: "",
            };
            await this.$store.dispatch("concern/concernFilterAction", payload);
            this.loading = false;
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
    },
    async mounted() {
        this.loading = true;
        let payload = {
            name: "",
            type: "",
        };
        await this.$store.dispatch("concern/concernFilterAction", payload);
        this.loading = false;
    },
};
</script>
<style scoped>
.card.custome-card {
    border: 1px solid #ddd;
    border-radius: 12px;
}
.text-grey {
    color: #aaaa;
    background-color: transparent;
}


</style>
